module.exports = __webpack_public_path__ + "img/Img26c_158798_CeEt-7-6B4-1072.6776e5b7.jpg";